import { React, useState } from 'react';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const LeaseDetails = ({ leaseDetails, formData }) => {
    const { currencyPrecision } = useCurrency();
    return (
        <div className="my-3 border-box2 my-3 p-3" style={{ borderRadius: "8px" }}>
            <div className="form-group" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(500px, 2fr))', gap: '20px' }}>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant NO</label>
                    <input type="text" className="p-2 form-control w-75" value={leaseDetails?.Cust1_No} disabled name="remarks" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Security Deposit</label>
                    <input type="text" className="p-2 form-control w-75" value={formData?.securityDeposit} disabled name="periodto" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Tenant</label>
                    <input type="text" className="p-2 form-control w-75" value={leaseDetails?.Cust1_Name} disabled name="remarks" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Ejari Charges</label>
                    <input type="text" className="p-2 form-control w-75" value={"0.000"} disabled name="remarks" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Contact No</label>
                    <input type="text" className="p-2 form-control w-75" value={leaseDetails?.MainContactNo} disabled name="leaseTerm" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Parking Charges</label>
                    <input type="text" className="p-2 form-control w-75" value={leaseDetails?.ParkingCharge?.toFixed(currencyPrecision?.decimalNumbers) || "0.000"} disabled name="remarks" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Leaseing Person</label>
                    <input type="text" className="p-2 form-control w-75" value={leaseDetails?.SalesPerson} disabled name="installments" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Electrical Charges</label>
                    <input type="text" className="p-2 form-control w-75" value={leaseDetails?.ElectricalCharge?.toFixed(currencyPrecision?.decimalNumbers) || "0.000"} disabled name="remarks" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Agent</label>
                    <input type="text" className="p-2 form-control w-75" value={leaseDetails?.Agent} disabled name="remarks" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Leasing <br />Commission</label>
                    <input type="text" className="p-2 form-control w-75" value={"0.000"} disabled name="remarks" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Period From</label>
                    <input type="text" className="p-2 form-control w-75" value={leaseDetails?.Lease_Date} disabled name="remarks" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Admin / <br /> Leasing Fee</label>
                    <input type="text" className="p-2 form-control w-75" value={leaseDetails?.AdminFee?.toFixed(currencyPrecision?.decimalNumbers) || "0.000"} disabled name="remarks" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">Period to</label>
                    <input type="text" className="p-2 form-control w-75" value={leaseDetails?.Lease_Expiry} disabled name="remarks" />
                </div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start text-bold">Rent for the Period</label>
                    <input type="text" className="p-2 form-control w-75" value={leaseDetails?.MonthlyRent?.toFixed(currencyPrecision?.decimalNumbers) || "0.000"} disabled name="remarks" />
                </div>
                <div></div>
                <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start text-bold">No. of Installments</label>
                    <input type="text" className="p-2 form-control w-75" value={leaseDetails?.installment || "0"} disabled name="remarks" />
                </div>
            </div>
        </div>
    );
};
export default LeaseDetails;